module.exports = __webpack_public_path__ + "img/checkmark_s3.b980c246.svg";